// extracted by mini-css-extract-plugin
export var banner = "_ec-0";
export var closeButton = "_ec-2";
export var greenCheckmark = "_ec-3";
export var hereLink = "_ec-4";
export var titleIcon = "_ec-1";